module.exports = __webpack_public_path__ + "static/media/blbl_logo_white.67214bc1.svg";